document.addEventListener('scroll', ()=>{
    const header = document.querySelector('.cc-header');
    const categoryFilters = document.querySelector('.main-products-grid__category__filters');
    const facetFilters = document.querySelector('.main-products-grid__filters');
    const mobileNav = document.querySelector('.nav-mobile');

    const headerHeight = header.clientHeight;

    categoryFilters.style.top = `${headerHeight - 1}px`;
    facetFilters.style.top = `${headerHeight - 1}px`;
    categoryFilters.style.height = `calc(100vh - ${headerHeight + mobileNav.clientHeight + 5}px)`;
});